import React, { useState, useEffect } from "react";
import {
    CSelect
} from '@coreui/react'
import { useAppContext } from "../../context/AppContext";
import { Grid } from "@mui/material";
import { Colors } from "../../constants/Colors";
import CustomButton from "../../components/Button";
// import Card from "../../components/Card";
// import { apiRequest } from "../../services/api-request";
// import { useNavigate, useParams } from "react-router-dom";

//import sortIcon from "../bank-css/icons/table filter arrows.svg";
//import editIcon from "../bank-css/icons/Edit.svg";
//import deleteIcon from "../bank-css/icons/Delete.svg";
//import downloadIcon from "../bank-css/icons/download-iocn.svg";
//import reloadIcon from "../bank-css/icons/reload.svg";
import { apiRequest } from "../../services/api-request";
import { downloadFile } from "../../utilities/exportToCsv";


const ApplicationReport = () => {
    const { user = {} } = useAppContext();
    // const navigate = useNavigate();
    // const { userType } = useParams();
    const currentRole = user?.role?.code || null;
    const branch_id = user?.role?.branch_id || null;

    const [statistics, setStatistics] = useState({ total_farmers: 0, total_reports: 0, total_loan_value: 0 });
    const [reports, setReports] = useState([]);

    const [filters, setFilters] = useState({
        state_id: "",
        circle_id: "",
        regional_id: "",
        branch_id: "",
    });

    const [statesList, setStatesList] = useState([]);
    const [circleList, setCircleList] = useState([]);
    const [regionalList, setRegionalList] = useState([]);
    const [branchList, setBranchList] = useState([]);

    const [allReportCSV, setAllReportCSV] = useState({
        data: [],
        loader: false,
    });

    useEffect(() => {
        getStates();
    }, []);

    const getStates = () => {
        apiRequest({
            url: `master/states`,
            method: "GET",
        })
            .then((res) => {
                setStatesList(res?.data);
            })
            .catch((err) => {
                alert(err?.response?.data?.message, "error");
            });
    };

    useEffect(() => {
        if (filters.state_id) {
            getCirlces(filters.state_id);
        }
    }, [filters.state_id]);

    const getCirlces = (state_id) => {
        apiRequest({
            url: "bank/get-circle-office?state_id=" + state_id,
            method: "GET",
        })
            .then((res) => {
                setCircleList(res?.data);
                setFilters(prev => ({
                    ...prev,
                    circle_id: "",
                    regional_id: "",
                    branch_id: "",
                }));
            })
            .catch((err) => {
                alert(err?.response?.data?.message, "error");
            });
    };

    useEffect(() => {
        if (filters.circle_id) {
            getRegionals(filters.circle_id);
        }
    }, [filters.circle_id]);

    const getRegionals = (circle_id) => {
        apiRequest({
            url: "bank/get-regional-office?circle_id=" + circle_id,
            method: "GET",
        })
            .then((res) => {
                setRegionalList(res?.data);
                setFilters(prev => ({
                    ...prev,
                    regional_id: "",
                    branch_id: "",
                }));
            })
            .catch((err) => {
                alert(err?.response?.data?.message, "error");
            });
    };

    useEffect(() => {
        if (filters.regional_id) {
            getBranches(filters.regional_id);
        }
    }, [filters.regional_id]);

    const getBranches = (regional_id) => {
        apiRequest({
            url: "bank/get-branch?regional_id=" + regional_id,
            method: "GET",
        })
            .then((res) => {
                setBranchList(res?.data);
                setFilters(prev => ({
                    ...prev,
                    branch_id: ""
                }));
            })
            .catch((err) => {
                alert(err?.response?.data?.message, "error");
            });
    };

    const getReports = (appliedFilters = {}) => {
        appliedFilters.currentRole = currentRole
        appliedFilters.branch_id = branch_id
        apiRequest({
            url: "bank/get-reports",
            method: "POST",
            data: appliedFilters,
        })
            .then((res) => {
                setReports(res.data || []);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getStatistics = (appliedFilters = {}) => {
        appliedFilters.currentRole = currentRole
        appliedFilters.branch_id = branch_id
        apiRequest({
            url: "bank/get-reports-statistics",
            method: "POST",
            data: appliedFilters,
        })
            .then((res) => {
                setStatistics(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        const payload = Object.fromEntries(
            Object.entries(filters).filter(([_, v]) => v)
        );
        getReports(payload);
        getStatistics(payload);
    }, [filters]);

    const handleChange = (field) => (e) => {
        const value = e.target.value;
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    useEffect(() => {
        let headers = [
            "APPLICATION NO,APPLICANT NAME,LOAN AMOUNT,CIRCLE OFFICE,REGIONAL OFFICE,BRANCH,BRANCH CODE,DATE,STATUS",
        ];

        let reportCSV;

        if (Array.isArray(allReportCSV.data) && allReportCSV.data.length > 0) {
            reportCSV = allReportCSV.data.reduce((acc, buyRequest) => {
                acc.push([
                    buyRequest.req_id,
                    buyRequest.farmer_data.name,
                    `Rs. ${buyRequest.animal_price}`,
                    buyRequest.circle,
                    buyRequest.regional,
                    buyRequest.branch,
                    buyRequest.branch_code,
                    buyRequest.created_on,
                    buyRequest.status
                ]);
                return acc;
            }, []);

            downloadFile({
                data: [...headers, ...reportCSV].join("\n"),
                fileName: "Reports.csv",
                fileType: "text/csv",
            });
        }
    }, [allReportCSV]);

    const exportCSV = () => {
        setAllReportCSV({ data: [], loader: true });
        let payload = Object.fromEntries(
            Object.entries(filters).filter(([_, v]) => v)
        );
        payload.currentRole = currentRole
        payload.branch_id = branch_id
        apiRequest({
            url: "bank/get-reports",
            method: "POST",
            data: payload,
        })
            .then((res) => {
                setAllReportCSV({ data: res?.data, loader: false });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div>
            <div className="reports-page">
                <div className="reports-header">
                    <h1 className="dashboard-title">Application Reports</h1>
                    {/*<div className="reports-actions">
                    <button className="btn-download">
                        <img src={downloadIcon} alt="Download" />
                        <span>Download</span>
                    </button>
                    <button className="btn-reload">
                        <img src={reloadIcon} alt="Reload" />
                        <span>Reload</span>
                    </button>
                </div>*/}
                </div>
                {
                    currentRole !== 'branchManager' ?
                        <div className="report-filters-container">
                            <div className="filters-wrapper-1">
                                <div className="filter-input-wrapper">
                                    <label className="filter-input-label">State</label>
                                    {/*<select className="filter-input">
                                <option>Select</option>
                            </select>*/}
                                    <CSelect custom onChange={handleChange('state_id')} value={filters.state_id} className="filter-input">
                                        <option value="">--Select State--</option>
                                        {
                                            statesList.map((e, key) => {
                                                return <option key={key} value={e.id}>{e.display_name}</option>;
                                            })
                                        }
                                    </CSelect>
                                </div>
                                <div className="filter-input-wrapper">
                                    <label className="filter-input-label">Circle</label>
                                    <CSelect custom onChange={handleChange('circle_id')} value={filters.circle_id} className="filter-input">
                                        <option value="">--Select Circle--</option>
                                        {
                                            circleList.map((e, key) => {
                                                return <option key={key} value={e.id}>{e.name}</option>;
                                            })
                                        }
                                    </CSelect>
                                </div>
                                <div className="filter-input-wrapper">
                                    <label className="filter-input-label">Regional Office</label>
                                    <CSelect custom onChange={handleChange('regional_id')} value={filters.regional_id} className="filter-input">
                                        <option value="">--Select Regional--</option>
                                        {
                                            regionalList.map((e, key) => {
                                                return <option key={key} value={e.id}>{e.name}</option>;
                                            })
                                        }
                                    </CSelect>
                                </div>
                                <div className="filter-input-wrapper">
                                    <label className="filter-input-label">Branch</label>
                                    <CSelect custom onChange={handleChange('branch_id')} value={filters.branch_id} className="filter-input">
                                        <option value="">--Select Branch--</option>
                                        {
                                            branchList.map((e, key) => {
                                                return <option key={key} value={e.id}>{e.name} ({e.code})</option>;
                                            })
                                        }
                                    </CSelect>
                                </div>
                            </div>
                        </div> : null
                }

                <div className="grid grid-3" style={{ marginBottom: '32px' }}>
                    <div className="dashboard-card pink">
                        <div className="card-label">Total Customers</div>
                        <div className="card-value">{statistics.total_farmers}</div>
                    </div>
                    <div className="dashboard-card yellow">
                        <div className="card-label">Total Reports</div>
                        <div className="card-value">{statistics.total_reports}</div>
                    </div>
                    {/*<div className="dashboard-card blue">
                    <div className="card-label">Animals Vet Certified</div>
                    <div className="card-value">100</div>
                </div>*/}
                    <div className="dashboard-card green">
                        <div className="card-label">Total Loan Value</div>
                        <div className="card-value">Rs. {statistics.total_loan_value}</div>
                    </div>
                </div>

                <div>
                    <h2 className="section-title-medium" id="section-title" style={{ marginBottom: '16px', float: 'left' }}>Reports</h2>
                    <Grid style={{ marginBottom: '16px', float: 'right' }}>
                        <CustomButton
                            title={"Export List"}
                            padding={"4px 20px"}
                            handleButtonClick={exportCSV}
                            backgroundColor={Colors.headerColor}
                            textColor={Colors.white}
                            textFontSize={14}
                        />
                    </Grid>
                </div>

                <div className="table-container">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th className="col-app-no">
                                    <div className="th-content">
                                        <span>APPLICATION NO</span>
                                    </div>
                                </th>
                                <th className="col-applicant-name">
                                    <div className="th-content">
                                        <span>APPLICANT NAME</span>
                                    </div>
                                </th>
                                <th className="col-loan-amount">LOAN AMOUNT</th>
                                {/*<th className="col-animal-type">
                                <div className="th-content">
                                    <span>ANIMAL TYPE</span>
                                    <img src={sortIcon} alt="Sort" className="sort-icon" />
                                </div>
                            </th>*/}
                                <th className="col-branch-name">
                                    <div className="th-content">
                                        <span>CIRCLE OFFICE</span>
                                    </div>
                                </th>
                                <th className="col-branch-name">
                                    <div className="th-content">
                                        <span>REGIONAL OFFICE</span>
                                    </div>
                                </th>
                                <th className="col-branch-name">
                                    <div className="th-content">
                                        <span>BRANCH</span>
                                    </div>
                                </th>
                                <th className="col-branch-code">
                                    <div className="th-content">
                                        <span>BRANCH CODE</span>
                                    </div>
                                </th>
                                {/* <th className="col-created-at">
                                <div className="th-content">
                                    <span>DATE</span>
                                </div>
                            </th> */}
                                <th className="col-status">
                                    <div className="th-content">
                                        <span>STATUS</span>
                                    </div>
                                </th>
                                <th className="col-action">ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reports.length > 0 ?
                                    reports.map((e, key) => {
                                        return <tr key={key}>
                                            <td className="col-applicant-name">{e.req_id}</td>
                                            <td className="col-app-no">{e.farmer_data.name}</td>
                                            <td className="col-loan-amount">Rs. {e.animal_price}</td>
                                            <td className="col-branch-name">{e.circle || ''}</td>
                                            <td className="col-branch-name">{e.regional || ''}</td>
                                            <td className="col-branch-name">{e.branch || ''}</td>
                                            <td className="col-branch-code">{e.branch_code || ''}</td>
                                            {/* <td className="col-created-at">{e.created_on}</td> */}
                                            {
                                                e.status === 'Pending' ?
                                                    <td className="col-status"><span className="status-badge status-pending">{e.status}</span></td>
                                                    :
                                                    <td className="col-status"><span className="status-badge status-approved">{e.status}</span></td>
                                            }
                                            <td className="col-action">
                                                <div className="action-buttons">
                                                    {/*<button className="action-btn edit-btn" title="Edit">
                                                <img src={editIcon} alt="Edit" />
                                            </button>
                                            <button className="action-btn delete-btn" title="Delete">
                                                <img src={deleteIcon} alt="Delete" />
                                            </button>*/}
                                                    {
                                                        e.status === 'Pending' ? '' :
                                                            <a href={`report-details/${e.req_id}`} className="action-btn view-btn">View</a>
                                                    }
                                                </div>
                                            </td>
                                        </tr>;
                                    })
                                    :
                                    <p style={{ padding: '10px' }}>Reports not found</p>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ApplicationReport;